<template>
  <div :class="{
    'page-map': true,
    'page-map--preload-blur': preload && preload.type === 'scroll' && !dataReady
  }">
    <slot />
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import DataReadyMixin from '@/components/DataReadyMixin'
import PreloaderMixin from '@/components/googleMap/PreloaderMixin'

@Component({
  mixins: [
    PreloaderMixin,
    DataReadyMixin,
  ],
  props: {
    preload: {
      type: Object,
      required: false,
    },
  },
})
export default class GoogleMaps extends Vue {
}

</script>

<style lang="scss">
.page-map {
  max-width: 1240px;
  margin: 0 auto;
  position: relative;

  &--preload {
    overflow: hidden;
  }

  &--preload-blur [class*="map__wrapper"] {
    background: url('/assets/images/map-preloader.png');
    background-size: cover;
    background-position: center;
    filter: blur(2px);
  }

  button {
    outline: none;
  }

  .reset-map {
    width: 28px;
    height: 28px;
    background: url('/assets/images/Maps/Salesmap/others/marker_reset.png') no-repeat center;
    position: absolute;
    top: 10px;
    left: 10px;
    padding: 0;
    border: none;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GoogleMaps.vue